import { EventItem } from "JS/React/Components/EventItem";
import { InternalStandardProps, Box } from "@mui/material";
import { Layout } from "../Layout";
import { styled } from "@mui/material/styles";
import { AppTypography } from "JS/React/Components/AppTypography";
import { useNavigate } from "react-router-dom";
import { useRouting } from "JS/React/Hooks/Routes";
import { AppHeader } from "JS/React/Components/AppHeader";
import { useGetEvents, useGlobalEvents } from "JS/React/Hooks/Events";
import { messaging } from "JS/Helpers/UserMessaging";
import { AppBackdropProgress } from "JS/React/Components/Progress/AppBackdropProgress";
import { useGlobalNavStack } from "JS/React/Hooks/NavStack";
import { Tabs } from "JS/Helpers/FycStatusConstants";
import { useEffect } from "react";
import { EventActions, EventCategories, EventNames } from "JS/Models";
import { useFirebaseLogger } from "JS/React/Hooks/Firebase";

const StyledRoot = styled("div")({});

const StyledMessageContainer = styled(Box)({
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    padding: "0 20px",
    width: "100%",
    position: "fixed",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
});

const StyledMessage = styled(AppTypography)(({ theme }) => ({
    textAlign: "center",
    color: theme.palette.grey.A100,
}));

export interface EventsProps
    extends InternalStandardProps<
        React.DetailedHTMLProps<
            React.HTMLAttributes<HTMLDivElement>,
            HTMLDivElement
        >
    > {}

export const Events = (props: EventsProps) => {
    const { className, ...rest } = props;
    const { homeStack } = useGlobalNavStack();
    const { events: eventList } = useGlobalEvents();
    const { logFirebaseEvent } = useFirebaseLogger();

    const { linkProvider } = useRouting();
    const navigate = useNavigate();

    const {
        loading: loadingEvents,
        isErrorNoEvents,
        isErrorNoRegistered,
    } = useGetEvents(false);

    useEffect(() => {
        logFirebaseEvent(EventNames.EVENT_REGISTRATION_OPENED, {
            action: EventActions.OPEN,
            category: EventCategories.EVENTS,
        });
    }, []);

    return (
        <Layout>
            <StyledRoot {...rest} className={className}>
                <AppHeader
                    title={"My Event Registrations"}
                    canGoBack
                    searchable={false}
                    onBackClick={() => {
                        if (!homeStack?.isHomeTrack) {
                            navigate(linkProvider.react.more().index());
                        } else {
                            navigate(linkProvider.react.home());
                        }
                    }}
                />
                {loadingEvents && !isErrorNoEvents && !isErrorNoRegistered && (
                    <AppBackdropProgress
                        open={true}
                        backdropText={messaging.loader.tickets}
                    />
                )}
                {isErrorNoEvents && (
                    <StyledMessageContainer>
                        <StyledMessage variant="h6">
                            {messaging?.events?.noActiveEvent}
                        </StyledMessage>
                    </StyledMessageContainer>
                )}
                {isErrorNoRegistered && (
                    <StyledMessageContainer>
                        <StyledMessage variant="h6">
                            {messaging?.events?.noEventRegistration}
                        </StyledMessage>
                    </StyledMessageContainer>
                )}
                {!loadingEvents &&
                    eventList.map((event) => (
                        <EventItem
                            key={`${event.EventName}-${event.EventStartDateAndTime}`}
                            event={event}
                            onEventItemClick={(e, eventName) => {
                                navigate(
                                    linkProvider.react
                                        .events()
                                        .detail(eventName, Tabs.PRIMARY_USER),
                                );
                            }}
                        />
                    ))}
            </StyledRoot>
        </Layout>
    );
};
